const RenderIf = ({ isTrue, children }) => isTrue && children;

export default RenderIf;
